<template>
  <div></div>
</template>

<script>
/* eslint-disable */
  import { loginProc } from '@/common/utils/login'
import { parseUrl, stringify } from 'query-string'
import { PROMOTION_CODE_KEY } from '@/common/resources/const'

  export default {
    data() {
      return {
        signupResultCode: '302'
      };
    },
    methods: {
      snsLogin(snstype, token, returnurl, promotioncode = '') {
        // snstype : kakao, facebook, naver
        loginProc({userType: snstype, userId: token , userPassword: '', saveId: '', autoLogin: ''}).then((response) => {
          let destination = '/index.html'
          if (response.needselectprofile === 'y') {
            destination = '/member/profile_list.html?referer=/index.html'
          }
          window.location.href = destination
        }).catch((error) => {
          if (error.response.status === 551 &&
            error.response.data.resultcode === this.signupResultCode){
            const redirectURL = _.get(error, 'response.data.resultoptional', '')
            const {url, query} = parseUrl(redirectURL)
            query[PROMOTION_CODE_KEY] = promotioncode
            query['returnurl'] = returnurl
            window.location.href = url + '?' + stringify(query)
          } else {
            window.location.href = '/member/login.html'
          }
        });
      }
    },
    created() {
      const { query } = parseUrl(location.href)
      this.snsLogin(query.snstype, query.token, query.returnurl, query.promotioncode);
      //console.log('snstype :',this.snsQueryString('snstype'), 'token :', this.snsQueryString('token'), this.snsQueryString('returnurl'));
    }
  };
</script>
